var exports = {
  "V": "x1cb7f6e3--427c86--field-wrapper",
  "R": "x1cb7f6e3--427c86--hidden",
};

module.exports = exports;
